////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

// I. FILE HEADER
// BitsBound Documentation Pod - Container component for documentation page
// Created: 2025-12-08
// Purpose: Smart container that manages state for documentation Pea

// II. IMPORTS
import React from 'react';
import DocumentationPea from '../pea/Bitsbound_Kings_Home_Primary_SRC_Documentation_Lobby_Pea.js';

// III. TYPES
interface DocumentationPodProps {
    className?: string;
    initialSection?: string; // For deep-linking to specific sections (e.g., /docs/mcp)
}

// IV. COMPONENT
/**
 * DocumentationPod - Container component for the documentation page
 *
 * In the Pea/Pod pattern:
 * - Pod = Smart container (manages state, data fetching, business logic)
 * - Pea = Presentation component (renders UI)
 *
 * For documentation, the Pea handles its own section navigation state,
 * so the Pod is a simple pass-through wrapper.
 *
 * @param initialSection - Optional section ID for deep-linking (e.g., 'mcp' for /docs/mcp)
 */
const DocumentationPod: React.FC<DocumentationPodProps> = ({ className, initialSection }) => {
    // V. RENDER
    // Pass through to Pea - documentation is mostly static content
    // Pea manages its own section navigation state
    return <DocumentationPea className={className} initialSection={initialSection} />;
};

// VI. EXPORTS
export default DocumentationPod;
